import { useTheme } from '@mui/material/styles';

export const useMainCardStyles = () => {
  const theme = useTheme();
  return {
    root: {
      marginTop: theme.spacing(1),
    },
    col: {
      display: 'flex',
      flexDirection: 'column' as const,
      alignItems: 'start',
    },
    heading: {
      color: 'white',
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        background: theme.palette.primary.main,
      },
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    euLogo: {
      width: "30px",
      marginTop: "5px"
    }
  };
};
